import { getLanguage, l, t } from "../core/i18n.js";
import {
  api,
  deleteAccount,
  flush,
  getSyncInfo,
  resolveConflict,
} from "../services/storage.js";
import { esc } from "../core/model.js";
import { googleMark, startGoogle } from "./auth-page.js";
import { runtime } from "../core/runtime.js";
export function updateAccountUI() {
  const { session, status } = getSyncInfo();
  const button = document.getElementById("accountBtn");
  if (button) {
    button.textContent = session?.user?.email || l("Guest workspace");
    button.title = l("Account and saving");
  }
  const statusElement = document.getElementById("syncStatus");
  if (statusElement) statusElement.textContent = status;
  const settingsStatus = document.getElementById("settingsSyncStatus");
  if (settingsStatus) settingsStatus.textContent = status;
}
export function accountSection() {
  const { session, status } = getSyncInfo();
  return (
    l('<div class="panel setting-section"><h3>Account & saving</h3><p>') +
    (session?.user
      ? esc(session.user.email)
      : l(
          "Use this guest workspace or create an account to open your planner on other devices.",
        )) +
    l(
      '</p><div class="data-actions"><button class="btn black" data-account>Manage account</button><span class="account-sync" id="settingsSyncStatus">',
    ) +
    esc(status) +
    "</span></div></div>"
  );
}
function accountExtras(user) {
  const language = getLanguage();
  const confirm = user.password
    ? `<label for="deletePassword">${t("Enter your password to confirm")}</label><input class="field" id="deletePassword" type="password" autocomplete="current-password" required maxlength="256">`
    : `<label for="deleteEmail">${t("Type {email} to confirm", { email: esc(user.email) })}</label><input class="field" id="deleteEmail" type="email" autocomplete="off" required maxlength="254">`;
  return `${user.verified ? "" : `<div class="account-verify" hidden><p>${t("Your email isn’t confirmed yet. Confirm it so you can always recover your account.")}</p><button class="btn" type="button" data-send-verification>${t("Send confirmation email")}</button></div>`}<details class="account-danger"><summary>${t("Delete account")}</summary><p>${t("This permanently deletes your account, plans and history. It cannot be undone. Export your data from Settings first if you want a copy.")}</p><form id="deleteAccountForm">${confirm}<button class="btn danger" type="submit">${t("Delete my account permanently")}</button></form></details><p class="account-legal"><a href="/${language}/privacy" target="_blank" rel="noopener">${t("Privacy policy")}</a> · <a href="/${language}/terms" target="_blank" rel="noopener">${t("Terms of use")}</a></p>`;
}
export function openAccount(mode = "register") {
  const { session, status, conflict, requiresLogin } = getSyncInfo();
  if (requiresLogin) {
    location.assign("/login");
    return;
  }
  const signedIn = !!session?.user;
  if (!signedIn && !conflict) {
    location.assign(mode === "login" ? "/login" : "/signup");
    return;
  }
  const host = document.getElementById("modal");
  host.innerHTML =
    '<div class="modal account-modal"><div class="eyebrow">DayX</div><h2>' +
    (conflict
      ? l("Review your changes")
      : signedIn
        ? l("Your workspace")
        : mode === "login"
          ? l("Welcome back")
          : l("Save your progress")) +
    "</h2>" +
    (conflict
      ? l(
          '<p>Plans changed on another device. Your local changes are still saved here. Choose the version to continue with; export a backup from Settings first if you need both.</p><div class="modal-actions"><button class="btn" data-use-server>Use server version</button><button class="btn black" data-use-local>Keep device changes</button></div>',
        )
      : signedIn
        ? "<p>" +
          esc(session.user.email) +
          '</p><p class="account-sync">' +
          esc(status) +
          `</p><div class="account-google"><p>${session.user.google ? l("Google account connected.") : l("Connect Google to log in with one click.")}</p>${session.user.google ? "" : `<button class="google-button" type="button" data-connect-google>${googleMark}${l("<span>Connect Google</span></button>")}`}</div>${accountExtras(session.user)}${l('<div class="modal-actions"><button class="btn" data-close>Close</button><button class="btn black" data-logout>Sign out</button></div>')}`
        : "<p>" +
          (mode === "register"
            ? l(
                "Your current plans move into your new account. You can then sign in on another device.",
              )
            : l(
                "Sign in to open your account’s plans. Your guest workspace remains saved separately on this device.",
              )) +
          l(
            '</p><form id="accountForm"><label for="accountEmail">Email</label><input class="field" id="accountEmail" type="email" autocomplete="email" required maxlength="254"><label for="accountPassword">Password · 8 characters minimum</label><input class="field" id="accountPassword" type="password" autocomplete="',
          ) +
          (mode === "register" ? "new-password" : "current-password") +
          l(
            '" required minlength="8" maxlength="256"><p class="form-error" id="accountError" role="alert"></p><div class="modal-actions"><button class="btn" type="button" data-close>Cancel</button><button class="btn black" type="submit">',
          ) +
          (mode === "register" ? l("Create account") : l("Sign in")) +
          '</button></div></form><button class="account-mode" data-account-mode>' +
          (mode === "register"
            ? l("Already have an account? Sign in")
            : l("Create a new account")) +
          "</button>") +
    '<p class="form-error" id="accountActionError" role="alert"></p></div>';
  host.classList.add("show");
  host
    .querySelector("[data-account-mode]")
    ?.addEventListener("click", () =>
      openAccount(mode === "login" ? "register" : "login"),
    );
  async function action(button, task) {
    button.disabled = true;
    try {
      await task();
    } catch (error) {
      host.querySelector("#accountError, #accountActionError").textContent =
        error.message;
      button.disabled = false;
    }
  }
  host.querySelector("#accountForm")?.addEventListener("submit", (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    action(form.querySelector("[type=submit]"), async () => {
      if (!(await flush()))
        throw new Error(
          l(
            "Your changes are still pending. Reconnect or review the saving status first.",
          ),
        );
      await api("/api/auth/" + mode, {
        method: "POST",
        data: {
          email: form.querySelector("#accountEmail").value,
          password: form.querySelector("#accountPassword").value,
        },
      });
      location.reload();
    });
  });
  host.querySelector("[data-logout]")?.addEventListener("click", (event) =>
    action(event.currentTarget, async () => {
      if (!(await flush()))
        throw new Error(l("Save your pending changes before signing out."));
      await api("/api/auth/logout", { method: "POST", data: {} });
      runtime.skipUnloadSave = true;
      location.assign("/login");
    }),
  );
  const verifyBox = host.querySelector(".account-verify");
  if (verifyBox)
    api("/api/auth/config")
      .then((config) => (verifyBox.hidden = !config.email))
      .catch(() => {});
  host
    .querySelector("[data-send-verification]")
    ?.addEventListener("click", (event) => {
      const button = event.currentTarget;
      action(button, async () => {
        await api("/api/auth/email/send", {
          method: "POST",
          data: { language: getLanguage() },
        });
        button.textContent = t("Email sent. Check your inbox.");
      });
    });
  host
    .querySelector("#deleteAccountForm")
    ?.addEventListener("submit", (event) => {
      event.preventDefault();
      const form = event.currentTarget;
      action(form.querySelector("[type=submit]"), async () => {
        await deleteAccount({
          password: form.querySelector("#deletePassword")?.value,
          email: form.querySelector("#deleteEmail")?.value,
        });
        runtime.skipUnloadSave = true;
        location.assign("/?account=deleted");
      });
    });
  const connect = host.querySelector("[data-connect-google]");
  if (connect) {
    connect.disabled = true;
    api("/api/auth/config")
      .then((config) => {
        connect.disabled = !config.google;
        if (!config.google)
          connect.insertAdjacentHTML(
            "afterend",
            l(
              '<p class="auth-provider-note">Google sign-in is coming soon.</p>',
            ),
          );
      })
      .catch(() => {});
    connect.onclick = () => action(connect, () => startGoogle("link"));
  }
  host
    .querySelector("[data-use-server]")
    ?.addEventListener("click", (event) =>
      action(event.currentTarget, () => resolveConflict("server")),
    );
  host
    .querySelector("[data-use-local]")
    ?.addEventListener("click", (event) =>
      action(event.currentTarget, () => resolveConflict("local")),
    );
}
export function bindAccount() {
  document
    .getElementById("accountBtn")
    .addEventListener("click", () => openAccount());
  document
    .getElementById("accountMobile")
    .addEventListener("click", () => openAccount());
  document
    .getElementById("syncStatus")
    .addEventListener("click", () => openAccount());
  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-account]")) openAccount();
  });
  window.addEventListener("planner:sync", updateAccountUI);
  updateAccountUI();
}
